<template>
  <v-card :class="[$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
        <i class="material-icons icon">picture_as_pdf</i>תוכניות בנייה
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-if="!$root.device.isMobile" dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
      <v-icon v-else @click="$root.activeMobileMenu=true" class="btnIcon mr-2 ml-2">menu</v-icon>
    </v-toolbar>
    <!--<h3>דף זה נמצא בשלבי פיתוח</h3>-->
    <div style="width: 100%;">
      <div style="text-align: right;">
        <v-icon @click="addNew" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
      </div>
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
        <tr class="trPrint trHeader">
          <th class="tdData sp">שם תוכנית</th>
          <th class="tdData" v-if="!$root.device.isMobile">תיאור</th>
          <th class="tdData">פרויקט</th>
          <th class="tdData" v-if="!$root.device.isMobile">תאריך יצירה</th>
          <th class="tdData">תאריך עדכון</th>
          <th class="tdCtrl" style="width: 160px!important;"></th>
        </tr>
      </table>
      <div class="scrollContent" v-if="hasData">
        <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
          <tr v-for="row in filteredRows">
            <td class="tdData sp">{{row.Name}}</td>
            <td class="tdData tdTxt" v-if="!$root.device.isMobile">{{row.Info}}</td>
            <td class="tdData tdTxt">{{row.ProjectName}}</td>
            <td class="tdData tdTxt" v-if="!$root.device.isMobile">{{row.CreateDate}}</td>
            <td class="tdData tdTxt">{{row.UpdateDate}}</td>
            <td class="tdCtrl tdTxt" style="width: 160px!important;">
              <v-icon @click="open(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'פתח תוכנית' }">reply_all</v-icon>
              <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
              <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
            </td>
          </tr>
        </table>
      </div>
      <div fluid v-else>
        <h3 style="padding-top: 40px;">אין נתונים</h3>
      </div>
      <PopupPlan></PopupPlan>
    </div>
  </v-card>
</template>

<script>

  import { db } from '../firebase';
  var plansRef = db.ref('Plans');
  import PopupPlan from '../components/PopupPlan';

  export default {
    name: 'Plans',
    components: { PopupPlan },
    data() {
      return {
        txtSearch: '',
        plans: [],
        isActiveUsers: false,
        popup: {
          isVisible: false,
          isEdit: false,
          title: '',
          data: {
            '.key': '',
            Title: '',
            Info: '',
            UserKey: '',
            ProjectKey: '',
            ProjectName: '',
            //Files: [],
            CreateDate: '',
            UpdateDate: '',
          },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        plans: vm.$root.isAdmin ? plansRef.orderByKey() : plansRef.orderByChild("UserKey").equalTo(vm.$root.user['.key']),
      }
    },
    created() {
      this.$Log("Vue [Plans] is created ...");
    },
    ready() {
      this.$Log("Vue [Plans] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Plans] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Plans] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            result = vm.plans.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  return row;
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          result = vm.plans;
        }

        return result;
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemovePlan') {
          this.remove();
        }
      }
    },
    methods: {
      addNew() {
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'תוכנית בנייה חדשה',
          data: {
            '.key': '',
            Name: '',
            Info: '',
            UserKey: '',
            ProjectKey: '',
            ProjectName: '',
            //Files: [],
            CreateDate: '',
            UpdateDate: '',
          },
        };
      },
      open(row) {
        let routeData = this.$router.resolve({ name: 'Plan', params: { planKey: row['.key'] } });

        if (this.$root.device.isTablet) {
          this.$router.push({ name: 'Plan', params: { planKey: row['.key'] } });
        }
        else {
          window.open(routeData.href, '_blank');
        }
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת תוכנית בנייה',
          data: {
            '.key': row['.key'],
            Name: row.Name,
            Info: row.Info,
            UserKey: row.UserKey,
            ProjectKey: row.ProjectKey,
            ProjectName: row.ProjectName,
            //Files: row.Files,
            CreateDate: row.CreateDate,
            UpdateDate: this.$moment().format('DD/MM/YYYY'),
          },
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemovePlan',
          isConfirmed: false
        }
      },
      remove() {
        plansRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        var item = {
          Name: this.popup.data.Name,
          Info: this.popup.data.Info,
          UserKey: this.$root.user['.key'],
          ProjectKey: this.popup.data.ProjectKey,
          ProjectName: this.popup.data.ProjectName,
          //Files: this.popup.data.Files,
          CreateDate: this.$moment().format('DD/MM/YYYY'),
          UpdateDate: this.$moment().format('DD/MM/YYYY')
        };

        const ref = plansRef.push(item);
        const newKey = ref.key;
        //alert(newKey)
        //PlaneFiles
        var planFilesPath = 'PlaneFiles/' + newKey + '/Root/Title';
        var planFilesRef = db.ref(planFilesPath);
        planFilesRef.set(item.Name);
      },
      update() {
        var item = {
          Name: this.popup.data.Name,
          Info: this.popup.data.Info,
          UserKey: this.$root.user['.key'],
          ProjectKey: this.popup.data.ProjectKey,
          ProjectName: this.popup.data.ProjectName,
          //Files: this.popup.data.Files,
          CreateDate: this.popup.data.CreateDate,
          UpdateDate: this.$moment().format('DD/MM/YYYY')
        };
        plansRef.child(this.popup.data['.key']).set(item);

        var planFilesPath = 'PlaneFiles/' + this.popup.data['.key'] + '/Root/Title';
        var planFilesRef = db.ref(planFilesPath);
        planFilesRef.set(this.popup.data.Name);
      }
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// Plans.vue?2310734e